import * as React from 'react';
const PediculosiIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M84.93 122.66c.38 15.11 10.62 15.89 12.7 15.89 5.35 0 10.75-3.63 10.75-11.73 0-4.05-1.54-6.34-2.46-7.71-.28-.41-.51-.75-.66-1.37-.42-1.66.42-3.36 1.99-4.04.4-.17.79-.29 1.14-.29 3.25 0 6.7 1.68 15.08 1.68h21.79M54.75 115.08h11.73c1.99 0 2.22.02 3.75-.12"
      className="prefix__cls-2"
    />
    <path
      d="M91.67 119.8c-.03.67-.05 1.33-.05 1.99 0 7.65 2.86 10.05 6.01 10.05 2.62 0 4.05-1.68 4.05-5.03 0-4.68-3.35-3.42-3.35-11.73 0-23.57 16.76-53.62 16.76-53.62"
      className="prefix__cls-2"
    />
    <path
      d="M115.08 61.46s-12.68 19.47-19.39 39.43"
      className="prefix__cls-2"
    />
    <circle cx={83.44} cy={108.18} r={8.18} className="prefix__cls-1" />
    <circle cx={83.44} cy={108.18} r={1.17} className="prefix__cls-1" />
  </svg>
);
export default PediculosiIcon;
